import React from "react";
import DefaultLayout from "./DefaultLayout";
import classnames from "classnames";
import PieChart from "../charts/PieChart";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import "./PrintStyle.css";

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"];

class PieChartLayout extends DefaultLayout {
  render() {
    const { metric, visible, index } = this.props;
    const { data, isLoading } = this.state;
    return (
      <div
        className={classnames("shadow", "col-12", "p-0", "mt-4", {
          "d-none": visible === false,
        })}
      >
        <div
          className="p-3"
          style={{
            backgroundColor: COLORS[index % COLORS.length],
            color: "white",
          }}
        >
          <div className="text-align-left title">{metric.title}</div>
          <div className="text-align-left description">
            {metric.description}
          </div>
        </div>
        <div className="p-0 p-lg-4 border bg-white">
          {isLoading ? (
            <Loading />
          ) : (
            <PieChart data={data} show_percentage={metric.show_percentage} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    group_ids: state.filters.group_ids,
    resident_id: state.filters.resident_id,
    filter_by_resident: state.filters.filter_by_resident,
    group_categories: state.filters.group_categories,
    resident_statuses: state.filters.resident_statuses,
    start_date: state.filters.start_date,
    end_date: state.filters.end_date,
    isLoading: true,
    processing: true,
  };
}

export default connect(mapStateToProps)(PieChartLayout);
